import gql from "graphql-tag";

export const queryEvents = gql`
  query (
    $date: [Date!]
    $depth: [Float!]
    $ml: [Float!]
    $dateTime: DateTime
    $needHaspga: Boolean!
  ) {
    eventList(
      QueryEvent: { depth: $depth, date: $date, ml: $ml, dateTime: $dateTime }
      needHaspga: $needHaspga
    ) {
      DateUTC
      Depth
      Latitude
      Longitude
      ML
      hasPGA @include(if: $needHaspga)
    }
  }
`;
export const queryPGA = gql`
  query ($staCode: String, $event: DateTime) {
    PGAList(event: $event, staCode: $staCode) {
      az
      event
      dist
      staCode
      pga
      pgv
    }
  }
`;
export const queryRealtimePGA = gql`
  query ($recordTime: Float, $type: Int, $token: String) {
    realtimePGA(recordTime: $recordTime, type: $type, token: $token) {
      dataVals
      timestamp
    }
  }
`;
export const queryStations = gql`
  query ($staFilter: staList_filter_choices) {
    stationList(staFilter: $staFilter) {
      staInfos
      timestamp
      version
    }
  }
`;
export const queryWaveforms = gql`
  query ($station: [String!], $event: [DateTime!]) {
    waveforms(station: $station, event: $event) {
      staCode
      event
      waveform
    }
  }
`;
export const queryEventFiles = gql`
  query ($event: DateTime, $fileType: eventFile_choices) {
    eventFiles(fileType: $fileType, event: $event) {
      data
      name
    }
  }
`;

export const queryDownloadLog = gql`
  query {
    downloadLogs {
      affiliation
      email
      sizeBytes
      event
      station
      timestamp
    }
  }
`;

export const queryRecaptcha = gql`
  mutation ($recaptcha: String!) {
    tokenAuth(recaptcha: $recaptcha) {
      errors
      success
    }
  }
`;
